import { createAccessService } from '@/services/shared/create-access-service';

// View-only chat sharing: grants are viewer-only and the owner
// is implicit on the conversation record, so there is no role management.
const conversationAccessService = createAccessService({
  pathSegment: 'conversation-access',
  sentryContext: 'share-conversation',
  notGrantedReason: 'Not a member of this organization',
});

export const shareConversation = conversationAccessService.share;
export const listConversationAccess = conversationAccessService.listAccess;
export const revokeConversationAccess = conversationAccessService.revokeAccess;
